import cloneDeep from 'lodash/cloneDeep';

export function getPureTextFromHtml(s) {
  var parser = new DOMParser();
  var htmlDoc = parser.parseFromString(
    '<p id="__content__title">' + s + '</p>',
    'text/html'
  );
  return htmlDoc.getElementById('__content__title').textContent;
}

export function storeToServer(task, stub = false) {
  const newTask = cloneDeep(task);
  if (stub) {
    newTask.stub = true;
    delete newTask.followers;
    delete newTask.assignee;
    delete newTask.verifiers;
  } else {
    newTask.followers = Object.values(newTask.followers);
    newTask.assignee = Object.values(newTask.assignee);
    newTask.verifiers = Object.values(newTask.verifiers);
  }
  if (newTask.relatedProviderItemId) {
    newTask.relatedProviderItemId = newTask.relatedProviderItemId.id;
  }
  if (newTask.printTemplate) {
    newTask.printTemplate = JSON.stringify(newTask.printTemplate);
  }
  return newTask;
}

export function serverToStore(task) {
  const newTask = { ...task };
  if (!newTask.assignee) {
    newTask.assignee = {};
  } else {
    newTask.assignee = Object.values(newTask.assignee)?.reduce((accu, curr) => {
      const idx =
        curr.userId || curr.properties.roleId || curr.properties.projectRoleId;
      accu[idx] = curr;
      return accu;
    }, {});
  }
  if (!newTask.verifiers) {
    newTask.verifiers = {};
  } else {
    newTask.verifiers = Object.values(newTask.verifiers)?.reduce(
      (accu, curr) => {
        const idx =
          curr.userId ||
          curr.properties.roleId ||
          curr.properties.projectRoleId;
        accu[idx] = curr;
        return accu;
      },
      {}
    );
  }
  if (!newTask.followers) {
    newTask.followers = [];
  } else {
    newTask.followers = Object.values(newTask.followers)?.reduce(
      (accu, curr) => {
        accu[curr.userId] = curr;
        return accu;
      },
      {}
    );
  }
  if (!newTask.reminderInfos) {
    newTask.reminderInfos = [];
  }
  if (!newTask.deleteState) {
    newTask.deleteState = null;
  }
  if (!newTask.relatedProviderItemId) {
    newTask.relatedProviderItemId = null;
  } else {
    newTask.relatedProviderItemId = {
      id: newTask.relatedProviderItemId,
      providerId: null,
    };
  }
  if (!newTask.printTemplate) {
    newTask.printTemplate = null;
  } else {
    let parsed;
    try {
      parsed = JSON.parse(newTask.printTemplate);
    } catch {
      parsed = null;
    }
    newTask.printTemplate = parsed;
  }
  if (!newTask.order) {
    newTask.order = newTask.id;
  }
  newTask.textTitle = getPureTextFromHtml(newTask.title);
  delete newTask['verifier'];
  return newTask;
}

export function stateToServer(task) {
  const newTask = { ...task };
  newTask.followers = Object.values(task.followers || {});
  newTask.assignee = Object.values(task.assignee || {});
  newTask.verifiers = Object.values(task.verifiers || {});
  if (newTask.relatedProviderItemId) {
    newTask.relatedProviderItemId = newTask.relatedProviderItemId.id;
  }
  if (newTask.printTemplate) {
    try {
      newTask.printTemplate = JSON.stringify(task.printTemplate);
    } catch {
      newTask.printTemplate = null;
    }
  }
  return newTask;
}

export function storeToState(task, users) {
  const newTask = { ...task };
  newTask.followers = Object.values(task.followers).reduce((accu, curr) => {
    const user = users[curr.userId];
    if (user) {
      accu[curr.userId] = { name: user.name, ...curr };
    }
    return accu;
  }, {});
  newTask.assignee = Object.entries(task.assignee || {}).reduce(
    (accu, [key, curr]) => {
      const user = curr.userId ? users[curr.userId] : null;
      if (user) {
        accu[curr.userId] = { name: user.name, ...curr };
      } else {
        accu[Number(key)] = { ...curr };
      }
      return accu;
    },
    {}
  );
  newTask.verifiers = Object.entries(task.verifiers || {}).reduce(
    (accu, [key, curr]) => {
      const user = curr.userId ? users[curr.userId] : null;
      if (user) {
        accu[curr.userId] = { name: user.name, ...curr };
      } else {
        accu[Number(key)] = { ...curr };
      }
      return accu;
    },
    {}
  );
  return newTask;
}
